'use client'

import { useEffect, useRef } from 'react'
import { GtmEventData, trackGtmEvent } from '@utils/analytics'

type GtmPageEventProps = {
  event: string
  data?: GtmEventData
}

export function GtmPageEvent({ event, data = {} }: GtmPageEventProps) {
  const tracked = useRef(false)

  useEffect(() => {
    if (tracked.current) return
    tracked.current = true
    trackGtmEvent(event, data)
  }, [data, event])

  return null
}
